//react
import clsx from 'clsx'
import { useState, useEffect, useContext, useMemo, useRef, Fragment } from 'react'
import Lottie from 'lottie-react'
import GlobalContext from '../../../../../../context/global-context'

//utils
import { formatCurrency, formatDate, formatRut } from '../../../../../utils/formatter'
import { getDocumentPdfKey, getDocumentPdfLookup } from '../../../../../../utils/documentPdfKey'
import { getCurrentDate } from '../../../../../utils/constant'

//ui
import EditOutlinedIcon from '@mui/icons-material/EditOutlined'
//import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
//import DoneAllIcon from '@mui/icons-material/DoneAll'
//import BlockIcon from '@mui/icons-material/Block'
import SearchIcon from '@mui/icons-material/Search'
//api
//import { OrganizationAPI } from '../../../../../../api/organization.api'
import businessApi from '../../../../../../api/business.api'
//components
import { Text } from '../../../../ui'
import { Spinner } from '../../../../ui/Spinner'
// import CustomPagination from '../../../../table/CustomPagination'
import ModalDialogMotionEditForm from '../../../../modalDialogEditarMovimiento/ModalDialogMotionEditForm'
import { Link, useMediaQuery } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import translations from '../../../../ui/traslation/traslationAdministracion.json'
import ModalViewAdministracion from '../../../../ui/tables/baseTable/ModalViewAdministracion'
//assets
import isologo_SII from '../../../../../../assets/isologo_SII.png'
import iconNuevo from '../../../../../../assets/iconos/iconNuevo.png'
import iconoEnlace from '../../../../../../assets/iconos/iconEnlace.png'
import StarIcon from '@mui/icons-material/StarOutlineOutlined'
import StarFullIcon from '@mui/icons-material/StarOutlined'
import { TablesAPI } from '../../../../../../api/table.api'
import CustomButton from '../../../../ui/CustomButton'
import ModalEditConciliar from '../../../../modalDialogEditarMovimiento/ModalEditConciliar'
import ModalGroupClassificationEdit from './ModalGroupClassificationEdit'
import LoaderAdm from '../../../../../../assets/svgIcons/LoaderAdm.json'

const TableIngresos = ({
  rows,
  getData,
  rowsPerPage,
  highlightedRows,
  toggleHighlight,
  setData,
  onSort,
  order,
  disableCreditNoteGrouping = false,
  folioFilter = ''
}) => {
  const [page] = useState(0)
  const { currentBusiness } = useContext(GlobalContext)
  //const organizationAPI = new OrganizationAPI()
  const [switchGetData, setSwitchGetData] = useState(false)
  const [currentDate] = useState(getCurrentDate())
  const [open, setOpen] = useState(false)
  const tablesAPI = new TablesAPI()
  const [showPopup, setShowPopup] = useState(false);
  const [pendingApproval, setPendingApproval] = useState(null)
  const [, setIsCheckboxChecked] = useState(false);
  const [openConciliar, setOpenConciliar] = useState(false)
  const [dataModal, setDataModal] = useState({
    idLibro: '',
    status: '',
    nombreFolio: ''
  })
  const [openComprobante, setOpenComprobante] = useState(false)
  const [dataComprobante, setDataComprobante] = useState({
    libroId: '',
    nombreFolio: '',
    folio: ''
  })
  const [openGroupClassification, setOpenGroupClassification] = useState(false)
  const [groupClassificationData, setGroupClassificationData] = useState({
    idLibro: '',
    status: '',
    title: '',
    label: '',
    centroCostoLibroIds: [],
    summary: null
  })
  const [expandedGroups, setExpandedGroups] = useState({})
  const [fetchedBoletaDetails, setFetchedBoletaDetails] = useState({})
  const [loadingBoletaDetails, setLoadingBoletaDetails] = useState({})
  const [boletaMeta, setBoletaMeta] = useState({})
  const boletaObserversRef = useRef({})
  const [pdfLoadingId, setPdfLoadingId] = useState(null)
  const [pdfAvailabilityByKey, setPdfAvailabilityByKey] = useState({})
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const handleComprobante = (libroId, nombreFolio, folio) => {
    setDataComprobante({ ...dataComprobante, libroId: libroId, nombreFolio, folio })
    setOpenComprobante(true)
  }

  const getPdfSummaryKey = row => getDocumentPdfKey(row)

  const handleOpenVentaPdf = async row => {
    if (!row?.query || !row?.numeroFolio || pdfLoadingId) return
    setPdfLoadingId(row.id)
    try {
      const { data } = await businessApi.getVentaDocumentPdfUrl({
        businessId: currentBusiness.id,
        ...getDocumentPdfLookup(row)
      })
      if (data?.pdfUrl) {
        window.open(data.pdfUrl, '_blank', 'noopener,noreferrer')
      }
    } catch (error) {
      console.error('Error al obtener el PDF del documento:', error)
    } finally {
      setPdfLoadingId(null)
    }
  }

  const styles = {
    table: 'w-full min-w-[980px] table-auto text-[0.65rem] sm:text-[0.725rem] border-collapse leading-tight font-sans',
    thead: 'sticky top-0 z-10 bg-white',
    th: 'py-2 px-1 sm:px-2 w-auto max-w-[120px] text-center break-words border-b border-gray-200 uppercase text-[0.55rem] sm:text-[0.6rem] font-bold text-gray-500',
    tr: 'border-b border-gray-100 hover:bg-gray-50 transition-colors',
    td: 'py-2 px-1 sm:px-2 w-auto max-w-[200px] text-center break-words align-middle',
    smallCol: 'w-auto max-w-[70px] sm:max-w-[80px]',
    wideCol: 'w-auto max-w-[220px] sm:max-w-[300px]',
    boldText: 'font-bold text-[0.6rem] sm:text-[0.65rem]',
    text: 'text-[0.6rem] sm:text-[0.705rem] text-gray-400 font-medium',
    pdfLink: 'text-[0.6rem] sm:text-[0.705rem] text-blue-600 hover:text-blue-800 hover:underline font-medium',
    pdfLinkCyan: 'text-[0.6rem] sm:text-[0.705rem] text-cyan-600 hover:text-cyan-800 hover:underline font-medium',
    dateHeader: 'bg-gray-50/80 backdrop-blur-sm border-y border-gray-200/50 py-2 px-4 text-left font-bold text-primary flex items-center gap-2 cursor-pointer hover:bg-gray-100 transition-colors group font-sans'
  }

  const normalizeText = value =>
    String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')

  const parseNumericValue = value => {
    if (typeof value === 'number') return value
    if (value == null || value === '') return null

    const direct = Number(value)
    if (Number.isFinite(direct)) return direct

    const sanitized = String(value).replace(/\s+/g, '').replace(/\./g, '').replace(',', '.')
    const fallback = Number(sanitized)
    return Number.isFinite(fallback) ? fallback : null
  }

  const parseDocumentCode = value => {
    if (value == null || value === '') return null

    const direct = Number(value)
    if (Number.isFinite(direct)) return direct

    const normalized = normalizeText(value)
    const numericMatch = normalized.match(/^(\d+)/)
    if (numericMatch) return Number(numericMatch[1])

    if (normalized === 'fel') return 33
    if (normalized === 'fna') return 34
    if (normalized === 'bel') return 39
    if (normalized === 'bee') return 41
    if (normalized === 'nce') return 61

    if (normalized.includes('boleta') && normalized.includes('exenta')) return 41
    if (normalized.includes('boleta')) return 39
    if (
      normalized.includes('factura') &&
      (normalized.includes('exenta') || normalized.includes('no afecta'))
    ) {
      return 34
    }
    if (normalized.includes('factura')) return 33
    if (normalized.includes('nota') && normalized.includes('credito')) return 61

    return null
  }

  const getRowDocumentCode = row => {
    if (!row) return null

    const codeCandidates = [
      row?.codigoFolio,
      row?.codigoDocumento,
      row?.codigoDocumentoSii,
      row?.code,
      row?.codigo,
      row?.tipoDocumento,
      row?.tipoDocumentoCodigo,
      row?.documentoCodigo,
      row?.tipoComprobanteId,
      row?.tipoComprobante?.id,
      row?.nombreFolio,
      row?.nombreDocumento,
      row?.tipoDocumentoNombre,
      row?.tipoComprobante?.name,
      row?.tipoComprobante
    ]

    return codeCandidates
      .map(parseDocumentCode)
      .find(value => Number.isFinite(value)) ?? null
  }

  const getRowDocumentQuantity = row => {
    const documentCode = getRowDocumentCode(row)
    const quantityCandidates = [
      row?.cantidadDocumentos,
      row?.cantidad_documentos,
      row?.cantidadDocs,
      row?.cantidad_docs,
      row?.cantidadOperaciones,
      row?.cantidad_operaciones,
      row?.numeroDocumentos,
      row?.numero_documentos,
      row?.documentCount,
      row?.documentsCount,
      row?.cantidad
    ]

    if ([39, 41, 48].includes(documentCode)) {
      quantityCandidates.push(
        row?.numeroFolio,
        row?.folio,
        row?.numero,
        row?.documentos,
        row?.totalOperaciones,
        row?.total_operaciones
      )
    }

    const quantity = quantityCandidates
      .map(parseNumericValue)
      .find(value => Number.isFinite(value) && value > 0)

    return quantity ?? 1
  }

  const isCreditNoteRow = row => {
    if (!row) return false
    const numericCode = getRowDocumentCode(row)
    if (numericCode === 61) return true

    const nameSource =
      row?.nombreFolio ??
      row?.nombreDocumento ??
      row?.tipoDocumentoNombre ??
      row?.tipoDocumento ??
      row?.documento ??
      row?.docName ??
      row?.documentName ??
      row?.nombre
    const name = normalizeText(nameSource)
    return (
      name === '61' ||
      name === 'nce' ||
      (name.includes('nota') && name.includes('credito'))
    )
  }

  const getReferenceDocCode = row => {
    const reference =
      row?.referencia ??
      row?.references?.[0] ??
      row?.referencias?.[0] ??
      row?.documentoReferencia ??
      row?.documentoRef ??
      row?.referenciaDocumento
    const candidates = [
      reference?.codigo,
      reference?.code,
      reference?.referenceCode,
      reference?.reference_code,
      reference?.tipo,
      reference?.tipoDocumento,
      reference?.referenceType,
      reference?.reference_type,
      reference?.dte_type_code,
      row?.codigoReferencia,
      row?.codigoDocumentoReferencia,
      row?.tipoDocumentoReferencia,
      row?.referenciaTipo,
      row?.tipoDocReferencia,
      row?.referenceCode,
      row?.reference_code,
      row?.referenceType,
      row?.reference_type
    ]

    return candidates
      .map(parseDocumentCode)
      .find(value => Number.isFinite(value)) ?? null
  }

  const isBoletaAccountRow = row => {
    const accountName = normalizeText(row?.nombreCuenta)
    return accountName.includes('boleta')
  }

  const isGroupedCreditNote = row => {
    if (!isCreditNoteRow(row)) return false
    const referenceDocCode = getReferenceDocCode(row)
    if (Number.isFinite(referenceDocCode)) {
      return [39, 41].includes(referenceDocCode)
    }
    return isBoletaAccountRow(row)
  }

  const getGroupedRowConfig = row => {
    const documentCode = getRowDocumentCode(row)
    const referenceDocCode = getReferenceDocCode(row)

    if (documentCode === 39) {
      return {
        type: 'doc39',
        code: 39,
        title: 'Boleta Electrónica',
        dayTitle: 'Total Oper. del día Boleta Electr.',
        weekTitle: 'Total Oper. de la semana Boleta Electr.',
        monthTitle: 'Total Oper. del mes Boleta Electr.',
        countLabel: 'documentos'
      }
    }

    if (documentCode === 41) {
      return {
        type: 'doc41',
        code: 41,
        title: 'Boleta Exenta Electrónica',
        dayTitle: 'Total Oper. del día Boleta Exenta Electr.',
        weekTitle: 'Total Oper. de la semana Boleta Exenta Electr.',
        monthTitle: 'Total Oper. del mes Boleta Exenta Electr.',
        countLabel: 'documentos'
      }
    }

    if (documentCode === 48) {
      return {
        type: 'doc48',
        code: 48,
        title: 'Total mes Comprobantes Pago Electrónico',
        countLabel: 'documentos'
      }
    }

    if (isGroupedCreditNote(row)) {
      const isBoletaExenta = referenceDocCode === 41
      return {
        type: `nce-${referenceDocCode || 'boleta'}`,
        code: 61,
        title: isBoletaExenta
          ? 'Total NCE Oper. del mes Boleta Exenta Electr.'
          : 'Total NCE Oper. del mes Boleta Electr.',
        countLabel: 'NCE'
      }
    }

    return null
  }

  const getMonthGroupData = row => {
    const rawDate =
      row?.fecha ??
      row?.fechaDocumento ??
      row?.fechaEmision ??
      row?.fecha_emision ??
      row?.fechaDoc
    if (!rawDate) return { key: 'sin-fecha', label: 'Sin fecha' }
    const date = new Date(rawDate)
    if (Number.isNaN(date.getTime())) return { key: 'sin-fecha', label: 'Sin fecha' }
    const month = String(date.getUTCMonth() + 1).padStart(2, '0')
    const year = date.getUTCFullYear()
    return { key: `${year}-${month}`, label: `${month}-${year}` }
  }

  const getWeekGroupData = row => {
    const rawDate = row?.fecha
    if (!rawDate) return null
    const date = new Date(rawDate)
    if (Number.isNaN(date.getTime())) return null

    const day = date.getUTCDate()
    const month = date.getUTCMonth() + 1
    const year = date.getUTCFullYear()
    const dayOfWeek = date.getUTCDay()
    const daysSinceMonday = (dayOfWeek + 6) % 7
    const lastDayOfMonth = new Date(Date.UTC(year, month, 0)).getUTCDate()

    const weekStart = Math.max(1, day - daysSinceMonday)
    const weekEnd = Math.min(lastDayOfMonth, day - daysSinceMonday + 6)
    const monthStr = String(month).padStart(2, '0')
    const weekStartStr = String(weekStart).padStart(2, '0')

    return {
      key: `${year}-${monthStr}-w${weekStartStr}`,
      label: `Semana desde el ${weekStartStr} hasta el ${String(weekEnd).padStart(2, '0')}`
    }
  }

  const getUniqueValue = (groupRows, field, fallback, multipleLabel) => {
    const values = Array.from(new Set(groupRows.map(r => r?.[field]).filter(Boolean)))
    if (values.length === 1) return values[0]
    if (values.length === 0) return fallback
    return multipleLabel
  }

  const getGroupedStatus = groupRows => {
    const normalizedStatuses = groupRows
      .map(row => String(row?.status || '').replace(/\s*undefined\s*/gi, '').trim().toUpperCase())
      .filter(Boolean)

    const activeStatuses = normalizedStatuses.filter(status => !status.includes('ANUL'))

    if (activeStatuses.length === 0) return 'ANULADO'

    const hasPartial = activeStatuses.some(
      status => status.includes('PARCIAL') && status.includes('COBRADO')
    )
    const hasPaid = activeStatuses.some(
      status => status.includes('COBRADO') && !status.includes('PARCIAL')
    )
    const hasPending = activeStatuses.some(
      status => status.includes('POR COBRAR') || (!status.includes('COBRADO') && !status.includes('PARCIAL'))
    )

    if (hasPartial || (hasPaid && hasPending)) return 'PARCIALMENTE COBRADO'
    if (hasPaid) return 'COBRADO'
    return 'POR COBRAR'
  }

  const buildGroupSummary = group => {
    const groupRows = group.rows || []
    const editableSourceRow =
      groupRows.find(row => {
        const normalizedStatus = String(row?.status || '')
          .replace(/\s*undefined\s*/gi, '')
          .trim()
          .toUpperCase()
        const isPartiallyAnulado =
          normalizedStatus.includes('PARCIAL') && normalizedStatus.includes('ANUL')
        const canEditAnulado =
          normalizedStatus.includes('ANULA FOLIO') || normalizedStatus.includes('ANULADO POR')
        return !normalizedStatus.includes('ANUL') || isPartiallyAnulado || canEditAnulado
      }) ?? null
    const editableRow = editableSourceRow ?? groupRows[0] ?? null
    const totals = groupRows.reduce(
      (acc, row) => {
        acc.montoTotal += Number(row?.montoTotal ?? 0)
        acc.montoIvaRetenido += Number(row?.montoIvaRetenido ?? 0)
        acc.montoNetoLiquido += Number(row?.montoNetoLiquido ?? 0)
        acc.montoExento += Number(row?.montoExento ?? 0)
        acc.documentCount += getRowDocumentQuantity(row)
        return acc
      },
      {
        montoTotal: 0,
        montoIvaRetenido: 0,
        montoNetoLiquido: 0,
        montoExento: 0,
        documentCount: 0
      }
    )

    const razonSocial = getUniqueValue(
      groupRows,
      'razonSocial',
      'Varios Clientes',
      'Varios Clientes'
    )
    const rut = getUniqueValue(groupRows, 'rut', 'Varios RUT', 'Varios RUT')
    const nombreCuenta = getUniqueValue(
      groupRows,
      'nombreCuenta',
      '-',
      'Varias clasificaciones'
    )
    const codigoCuenta =
      nombreCuenta === '-' || nombreCuenta === 'Varias clasificaciones'
        ? ''
        : getUniqueValue(groupRows, 'codigoCuenta', '', '')
    const usuarioClasificador = getUniqueValue(
      groupRows,
      'usuarioClasificador',
      'TryLuca',
      'Varios'
    )
    const groupedStatus = getGroupedStatus(groupRows)
    const anulados = groupRows.filter(row =>
      String(row?.status || '').toUpperCase().includes('ANUL')
    ).length

    return {
      key: group.key,
      rows: groupRows,
      label: group.label,
      title: group.title,
      countLabel: group.countLabel,
      code: group.code,
      count: totals.documentCount,
      razonSocial,
      rut,
      nombreCuenta,
      codigoCuenta,
      usuarioClasificador,
      status: groupedStatus,
      anulados,
      editableRowId: editableRow?.id ?? null,
      editableRowStatus: editableRow?.status ?? groupedStatus,
      isEditBlocked: !editableSourceRow,
      ...totals
    }
  }

  const isBoletaGroup = group => [39, 41].includes(Number(group?.code))

  const getBoletaDayInfo = row => {
    const rawDate = row?.fecha
    if (!rawDate) return null
    const date = new Date(rawDate)
    if (Number.isNaN(date.getTime())) return null
    return {
      year: date.getUTCFullYear(),
      month: date.getUTCMonth() + 1,
      day: date.getUTCDate()
    }
  }

  const BOLETAS_PAGE_SIZE = 15

  const fetchBoletasForGroup = async group => {
    if (!currentBusiness?.rutRepresentante) return
    const groupKey = group.key
    if (loadingBoletaDetails[groupKey]) return

    // Las boletas se agrupan por día (ver getGroupBucketData), así que todas las
    // filas de group.rows corresponden al mismo día: alcanza con fetchear una vez.
    const dayInfo = getBoletaDayInfo((group.rows || [])[0])
    if (!dayInfo) return
    const dayKey = `${groupKey}-${dayInfo.year}-${dayInfo.month}-${dayInfo.day}`

    if (fetchedBoletaDetails[dayKey]) return

    try {
      setLoadingBoletaDetails(prev => ({ ...prev, [groupKey]: true }))
      const dte = Number(group.code)
      const response = await businessApi.getBoletasElectronicasDetalle({
        businessId: currentBusiness.id,
        year: dayInfo.year,
        month: dayInfo.month,
        day: dayInfo.day,
        dte,
        limit: BOLETAS_PAGE_SIZE
      })
      const documents = response?.data?.documents || []
      const total = response?.data?.total ?? documents.length
      setFetchedBoletaDetails(prev => ({ ...prev, [dayKey]: documents }))
      setBoletaMeta(prev => ({
        ...prev,
        [dayKey]: {
          year: dayInfo.year,
          month: dayInfo.month,
          day: dayInfo.day,
          dte,
          total,
          skip: documents.length,
          hasMore: documents.length < total,
          loadingMore: false
        }
      }))
    } catch (error) {
      console.error('Error fetching boleta detail for group:', groupKey, error)
    } finally {
      setLoadingBoletaDetails(prev => ({ ...prev, [groupKey]: false }))
    }
  }

  const loadMoreBoletas = async dayKey => {
    const meta = boletaMeta[dayKey]
    if (!meta || !meta.hasMore || meta.loadingMore) return

    setBoletaMeta(prev => ({ ...prev, [dayKey]: { ...prev[dayKey], loadingMore: true } }))
    try {
      const response = await businessApi.getBoletasElectronicasDetalle({
        businessId: currentBusiness.id,
        year: meta.year,
        month: meta.month,
        day: meta.day,
        dte: meta.dte,
        limit: BOLETAS_PAGE_SIZE,
        skip: meta.skip
      })
      const documents = response?.data?.documents || []
      const total = response?.data?.total ?? meta.total
      const newSkip = meta.skip + documents.length

      setFetchedBoletaDetails(prev => ({
        ...prev,
        [dayKey]: [...(prev[dayKey] || []), ...documents]
      }))
      setBoletaMeta(prev => ({
        ...prev,
        [dayKey]: {
          ...prev[dayKey],
          total,
          skip: newSkip,
          hasMore: newSkip < total,
          loadingMore: false
        }
      }))
    } catch (error) {
      console.error('Error al cargar más boletas del día:', dayKey, error)
      setBoletaMeta(prev => ({ ...prev, [dayKey]: { ...prev[dayKey], loadingMore: false } }))
    }
  }

  const boletaSentinelRef = dayKey => node => {
    if (boletaObserversRef.current[dayKey]) {
      boletaObserversRef.current[dayKey].disconnect()
      delete boletaObserversRef.current[dayKey]
    }
    if (!node) return
    const observer = new IntersectionObserver(
      entries => {
        if (entries[0].isIntersecting) {
          loadMoreBoletas(dayKey)
        }
      },
      { rootMargin: '80px' }
    )
    observer.observe(node)
    boletaObserversRef.current[dayKey] = observer
  }

  useEffect(() => {
    return () => {
      Object.values(boletaObserversRef.current).forEach(observer => observer.disconnect())
    }
  }, [])

  const handleToggleGroup = group => {
    const groupKey = group.key
    const willExpand = !expandedGroups[groupKey]
    setExpandedGroups(prev => ({ ...prev, [groupKey]: willExpand }))
    if (willExpand && isBoletaGroup(group)) {
      fetchBoletasForGroup(group)
    }
  }

  const handleTogglePlainGroup = group => {
    setExpandedGroups(prev => ({ ...prev, [group.key]: !prev[group.key] }))
  }

  const getBoletaStatus = boleta =>
    boleta.anulado ? 'ANULADA' : boleta.estadoBoleta || boleta.revisionEstado || ''

  const renderBoletasList = (detailKey, { compact = false, loadingKey, dayRow, dayHasCentroCosto } = {}) => {
    if (!currentBusiness?.rutRepresentante) return null
    const isLoading = Boolean(loadingBoletaDetails[loadingKey || detailKey])
    const allBoletas = fetchedBoletaDetails[detailKey] || []
    const boletas = folioFilter
      ? allBoletas.filter(boleta => String(boleta.folio) === String(folioFilter))
      : allBoletas
    const loaderSize = compact ? 48 : 60

    if (!compact) {
      if (isLoading) {
        return (
          <tr className={clsx(styles.tr, 'bg-gray-50')}>
            <td className={styles.td} colSpan={orderableCols.length}>
              <div className='flex justify-center py-3'>
                <Lottie animationData={LoaderAdm} loop style={{ width: loaderSize, height: loaderSize }} />
              </div>
            </td>
          </tr>
        )
      }

      if (boletas.length === 0) {
        return (
          <tr className={clsx(styles.tr, 'bg-gray-50')}>
            <td className={styles.td} colSpan={orderableCols.length}>
              <Text className='text-xs text-gray-400 text-center py-2'>
                Los movimientos están siendo sincronizados, en unos minutos podrá ver el detalle aquí.
              </Text>
            </td>
          </tr>
        )
      }

      const meta = boletaMeta[detailKey]
      const rows = boletas.map((boleta, idx) => {
        const boletaStatus = getBoletaStatus(boleta)
        return (
          <tr className={clsx(styles.tr, 'bg-gray-50')} key={`${detailKey}-${boleta.folio}-${idx}`}>
            <td className={clsx(styles.td, styles.smallCol)}>
              <div className='flex items-center gap-2'>
                <img src={isologo_SII} className='h-5 w-auto rounded mt-2 ml-10' />
              </div>
            </td>
            <td className={styles.td}>
              {boleta.pdfUrl ? (
                <Text className={styles.pdfLink}>
                  <Link
                    href={boleta.pdfUrl}
                    target='_blank'
                    rel='noreferrer'
                    className={styles.pdfLink}
                    title='Ver PDF'
                  >
                    {boleta.folio}
                  </Link>
                </Text>
              ) : (
                <Text className={styles.boldText}>{boleta.folio}</Text>
              )}
            </td>
            <td className={styles.td}>
              {boleta.pdfUrl ? (
                <Link
                  href={boleta.pdfUrl}
                  target='_blank'
                  rel='noreferrer'
                  className={styles.pdfLinkCyan}
                >
                  Ver PDF
                </Link>
              ) : (
                <>
                  <Text className={styles.boldText}>
                    {dayRow?.razonSocial || 'Varios Clientes'}
                  </Text>
                  <Text className={styles.text}>
                    {(dayRow?.rut && formatRut(dayRow.rut)) || 'Varios RUT'}
                  </Text>
                </>
              )}
            </td>
            <td className={styles.td}>
              <Text className={styles.boldText}>
                {boleta.fecha ? formatDate(boleta.fecha) : '—'}
              </Text>
            </td>
            <td className={styles.td}>
              <Text className={styles.boldText}>{dayRow?.nombreCuenta}</Text>
            </td>
            <td className={styles.td}>
              <Text className={clsx(styles.boldText, 'text-right')}>
                {renderCentroCostoBadge(dayHasCentroCosto)}
              </Text>
            </td>
            <td className={styles.td}>
              <Text className={clsx(styles.boldText, 'text-right')}>
                {formatCurrency(boleta.total)}
              </Text>
              <Text className='text-right text-accent3'>IVA: {formatCurrency(boleta.iva)}</Text>
              <Text className='text-right text-gray-500'>Neto: {formatCurrency(boleta.neto)}</Text>
            </td>
            <td className={styles.td}>
              <span className={statusBadgeClass(boletaStatus)}>
                {normalizeStatus(boletaStatus) || '—'}
              </span>
            </td>
            <td className={styles.td} />
          </tr>
        )
      })

      if (meta?.hasMore && !folioFilter) {
        rows.push(
          <tr className={clsx(styles.tr, 'bg-gray-50')} key={`${detailKey}-sentinel`}>
            <td className={styles.td} colSpan={orderableCols.length}>
              <div ref={boletaSentinelRef(detailKey)} className='flex justify-center py-2'>
                {meta.loadingMore && (
                  <Lottie animationData={LoaderAdm} loop style={{ width: 32, height: 32 }} />
                )}
              </div>
            </td>
          </tr>
        )
      }

      return rows
    }

    if (isLoading) {
      return (
        <div className='flex justify-center py-3'>
          <Lottie animationData={LoaderAdm} loop style={{ width: loaderSize, height: loaderSize }} />
        </div>
      )
    }

    if (boletas.length === 0) {
      return (
        <Text className='text-[10px] text-gray-400 text-center py-2'>
          Los movimientos están siendo sincronizados, en unos minutos podrá ver el detalle aquí.
        </Text>
      )
    }

    const compactMeta = boletaMeta[detailKey]

    return (
      <div className='mt-2 space-y-1'>
        {boletas.map((boleta, idx) => {
          const boletaStatus = getBoletaStatus(boleta)
          return (
            <div
              key={`${detailKey}-${boleta.folio}-${idx}`}
              className='flex items-center justify-between bg-white rounded-lg text-[11px] px-2 py-1'
            >
              {boleta.pdfUrl ? (
                <Text className={styles.pdfLink}>
                  <Link
                    href={boleta.pdfUrl}
                    target='_blank'
                    rel='noreferrer'
                    className={styles.pdfLink}
                    title='Ver PDF'
                  >
                    {boleta.folio}
                  </Link>
                </Text>
              ) : (
                <span className='font-semibold'>{boleta.folio}</span>
              )}
              <span>{boleta.fecha ? formatDate(boleta.fecha) : '—'}</span>
              <span className={statusBadgeClass(boletaStatus)}>
                {normalizeStatus(boletaStatus) || '—'}
              </span>
              <div className='text-right'>
                <Text className='text-xs font-bold'>{formatCurrency(boleta.total)}</Text>
                <Text className='text-[11px] text-gray-500'>IVA: {formatCurrency(boleta.iva)}</Text>
                <Text className='text-[11px] text-gray-500'>Neto: {formatCurrency(boleta.neto)}</Text>
              </div>
            </div>
          )
        })}
        {compactMeta?.hasMore && !folioFilter && (
          <div ref={boletaSentinelRef(detailKey)} className='flex justify-center py-2'>
            {compactMeta.loadingMore && (
              <Lottie animationData={LoaderAdm} loop style={{ width: 28, height: 28 }} />
            )}
          </div>
        )}
      </div>
    )
  }

  const handleClickOpen = (idLibro, status) => {
    setDataModal({ ...dataModal, idLibro: idLibro, status: status })
    setOpen(true)
  }

  const handleClickConciliar = (idLibro, status, nombreFolio) => {
    setDataModal({ ...dataModal, idLibro: idLibro, status: status, nombreFolio })
    setOpenConciliar(true)
  }

  const handleClickOpenGroupClassification = group => {
    if (!group?.editableRowId || group?.isEditBlocked) return
    const centroCostoLibroIds = [
      ...new Set(
        (group.rows || [])
          .map(row => Number(row?.id))
          .filter(Number.isFinite)
      )
    ]

    setGroupClassificationData({
      idLibro: group.editableRowId,
      status: group.editableRowStatus,
      title: group.title,
      label: group.label,
      centroCostoLibroIds,
      summary: group
    })
    setOpenGroupClassification(true)
  }

  /*const handleClickApproved = async data => {
    ui.setLoader({ visible: true, text: 'editando datos' })
    const updateData = {
      cuentaContableId: null,
      glosa: '',
      vencimiento: data.fechaVencimiento,
      validation: 1
    }
    try {
      const response = await organizationAPI.patchDataLibroContable(
        currentBusiness.id,
        data.id,
        updateData
      )
      await getData()
      console.info(response)
    } catch (error) {
      console.error(error)
    } finally {
      ui.setLoader({ visible: false, text: '' })
    }
  }*/

  const orderableCols = [
    { col: '', field: null },
    { col: 'T. Doc/Folio', field: 'numeroFolio' },
    { col: 'Cliente', field: 'razonSocial' },
    { col: 'Fecha', field: 'fecha' },
    { col: 'Clasificación', field: 'nombreCuenta' },
    { col: 'Centro Costo', field: 'centroCosto' },
    { col: 'Monto', field: 'montoTotal' },
    { col: 'Status', field: 'status' },
    { col: 'Acciones', field: 'aprobado' }
  ]

  const getGroupBucketData = (row, groupConfig) => {
    if ([39, 41].includes(groupConfig.code)) {
      const dayInfo = getBoletaDayInfo(row)
      if (dayInfo) {
        const dayStr = String(dayInfo.day).padStart(2, '0')
        const monthStr = String(dayInfo.month).padStart(2, '0')
        return {
          key: `${dayInfo.year}-${monthStr}-${dayStr}`,
          label: `${dayStr}-${monthStr}-${dayInfo.year}`
        }
      }
    }
    return getMonthGroupData(row)
  }

  const displayRows = useMemo(() => {
    if (!rows || rows.length === 0) return []
    if (disableCreditNoteGrouping) {
      return rows.map(row => ({ type: 'row', row }))
    }

    const dayGroups = new Map()
    const weekGroups = new Map()
    const monthGroups = new Map()

    rows.forEach(row => {
      const groupConfig = getGroupedRowConfig(row)
      if (!groupConfig) return

      const { key: bucketKey, label: bucketLabel } = getGroupBucketData(row, groupConfig)
      const dayGroupKey = `${groupConfig.type}-${bucketKey}`
      if (!dayGroups.has(dayGroupKey)) {
        dayGroups.set(dayGroupKey, {
          key: dayGroupKey,
          label: bucketLabel,
          title: groupConfig.title,
          countLabel: groupConfig.countLabel,
          code: groupConfig.code,
          rows: []
        })
      }
      dayGroups.get(dayGroupKey).rows.push(row)

      if (isBoletaGroup(groupConfig)) {
        const { key: monthKey, label: monthLabel } = getMonthGroupData(row)
        const monthGroupKey = `${groupConfig.type}-month-${monthKey}`
        if (!monthGroups.has(monthGroupKey)) {
          monthGroups.set(monthGroupKey, {
            key: monthGroupKey,
            label: monthLabel,
            title: groupConfig.monthTitle || groupConfig.title,
            countLabel: groupConfig.countLabel,
            code: groupConfig.code,
            rows: [],
            weekGroupKeys: []
          })
        }
        const monthGroup = monthGroups.get(monthGroupKey)
        monthGroup.rows.push(row)

        const weekData = getWeekGroupData(row)
        const weekGroupKey = weekData ? `${groupConfig.type}-week-${weekData.key}` : dayGroupKey
        if (!weekGroups.has(weekGroupKey)) {
          weekGroups.set(weekGroupKey, {
            key: weekGroupKey,
            label: weekData?.label ?? bucketLabel,
            title: groupConfig.weekTitle || groupConfig.monthTitle || groupConfig.title,
            countLabel: groupConfig.countLabel,
            code: groupConfig.code,
            rows: [],
            dayGroupKeys: []
          })
        }
        const weekGroup = weekGroups.get(weekGroupKey)
        weekGroup.rows.push(row)
        if (!weekGroup.dayGroupKeys.includes(dayGroupKey)) {
          weekGroup.dayGroupKeys.push(dayGroupKey)
        }
        if (!monthGroup.weekGroupKeys.includes(weekGroupKey)) {
          monthGroup.weekGroupKeys.push(weekGroupKey)
        }
      }
    })

    const pushDayRows = (output, dayGroupKey) => {
      const dayGroup = dayGroups.get(dayGroupKey)
      if (!dayGroup) return
      dayGroup.rows.forEach((groupedRow, rowIndex) => {
        output.push({
          type: 'row',
          row: groupedRow,
          isGroupedDetail: true,
          groupKey: dayGroupKey,
          isLastGroupedRow: rowIndex === dayGroup.rows.length - 1
        })
      })
    }

    const pushDayGroupHeader = (output, dayGroupKey) => {
      const dayGroup = dayGroups.get(dayGroupKey)
      if (!dayGroup) return
      output.push({ type: 'group', group: buildGroupSummary(dayGroup) })

      if (expandedGroups[dayGroupKey]) pushDayRows(output, dayGroupKey)
    }

    const getWeekNumFromKey = weekGroupKey => Number(weekGroupKey.match(/-w(\d+)$/)?.[1] ?? 0)

    const pushMonthContents = (output, monthGroup) => {
      const orderedWeekGroupKeys = [...monthGroup.weekGroupKeys].sort(
        (a, b) => getWeekNumFromKey(a) - getWeekNumFromKey(b)
      )

      orderedWeekGroupKeys.forEach(weekGroupKey => {
        const weekGroup = weekGroups.get(weekGroupKey)
        if (!weekGroup) return

        const orderedDayGroupKeys = [...weekGroup.dayGroupKeys].sort()

        if (orderedDayGroupKeys.length <= 1) {
          orderedDayGroupKeys.forEach(dayGroupKey => pushDayRows(output, dayGroupKey))
          return
        }

        output.push({ type: 'week-group', group: buildGroupSummary(weekGroup) })
        if (!expandedGroups[weekGroupKey]) return
        orderedDayGroupKeys.forEach(dayGroupKey => pushDayRows(output, dayGroupKey))
      })
    }

    const output = []
    const insertedTopBuckets = new Set()

    rows.forEach(row => {
      const groupConfig = getGroupedRowConfig(row)

      if (!groupConfig) {
        output.push({ type: 'row', row })
        return
      }

      const { key: bucketKey } = getGroupBucketData(row, groupConfig)
      const dayGroupKey = `${groupConfig.type}-${bucketKey}`
      const groupedByMonth = isBoletaGroup(groupConfig)
      const topBucketKey = groupedByMonth
        ? `${groupConfig.type}-month-${getMonthGroupData(row).key}`
        : dayGroupKey

      if (insertedTopBuckets.has(topBucketKey)) return
      insertedTopBuckets.add(topBucketKey)

      if (!groupedByMonth) {
        pushDayGroupHeader(output, dayGroupKey)
        return
      }

      const monthGroup = monthGroups.get(topBucketKey)
      if (!monthGroup) return
      output.push({ type: 'month-group', group: buildGroupSummary(monthGroup) })

      if (!expandedGroups[topBucketKey]) return
      pushMonthContents(output, monthGroup)
    })

    return output
  }, [rows, disableCreditNoteGrouping, expandedGroups])

  const safeRowsPerPage = rowsPerPage || rows?.length || 0
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * safeRowsPerPage - displayRows.length) : 0

  useEffect(() => {
    if (!switchGetData) return
    getData()
    setSwitchGetData(false)
  }, [switchGetData])

  useEffect(() => {
    setExpandedGroups({})
    setFetchedBoletaDetails({})
    setLoadingBoletaDetails({})
  }, [rows, disableCreditNoteGrouping])

  useEffect(() => {
    const queries = Array.from(
      new Set((rows || []).filter(row => row?.query && row?.numeroFolio).map(row => row.query))
    )
    if (!currentBusiness?.id || !currentBusiness?.rutRepresentante || queries.length === 0) return

    let cancelled = false
    businessApi
      .getVentaDocumentPdfUrlsSummary({ businessId: currentBusiness.id, queries })
      .then(({ data }) => {
        if (!cancelled) setPdfAvailabilityByKey(prev => ({ ...prev, ...data }))
      })
      .catch(error => console.error('Error al obtener el resumen de PDFs:', error))

    return () => {
      cancelled = true
    }
  }, [rows, currentBusiness?.id])

  const obtenerAbreviatura = nombre => {
    return translations.documentosContables[nombre] || nombre // Si no encuentra la abreviatura, devuelve el nombre original.
  }

  const getRowDisplayTitle = row => {
    const documentCode = getRowDocumentCode(row)
    if ([39, 41].includes(documentCode)) {
      const groupConfig = getGroupedRowConfig(row)
      if (groupConfig?.dayTitle) return groupConfig.dayTitle
    }
    return obtenerAbreviatura(row.nombreFolio)
  }

  const getCleanStatus = row =>
    typeof row?.status === 'string'
      ? row.status.replace(/\s*undefined\s*/gi, '').trim()
      : ''

  const normalizeStatus = status =>
    String(status || '')
      .replace(/\s*undefined\s*/gi, '')
      .trim()
      .toUpperCase()

  const isPartiallyAnuladoStatus = status => {
    const normalized = normalizeStatus(status)
    return normalized.includes('PARCIAL') && normalized.includes('ANUL')
  }

  const isStatusActionBlocked = status => {
    const normalized = normalizeStatus(status)
    return normalized.includes('ANUL') && !isPartiallyAnuladoStatus(normalized)
  }

  const isEditActionBlocked = status => {
    const normalized = normalizeStatus(status)
    const canEditAnulado =
      normalized.includes('ANULA FOLIO') || normalized.includes('ANULADO POR')
    return !canEditAnulado && isStatusActionBlocked(normalized)
  }

  const statusTone = status => {
    const s = normalizeStatus(status)
    if (s.includes('PARCIAL') && s.includes('COBRADO')) return 'warning'
    if (s.includes('PARCIAL') && s.includes('ANUL')) return 'muted'
    if (s.includes('ANUL')) return 'muted'
    if (s.includes('COBRADO')) return 'success'
    if (s.includes('POR COBRAR')) return 'danger'
    return 'muted'
  }

  const statusBadgeClass = status => {
    const tone = statusTone(status)
    return clsx(
      'inline-flex items-center justify-center px-3 py-1 rounded-full text-[0.55rem] sm:text-[0.6rem] font-semibold tracking-wider leading-tight',
      {
        'text-danger bg-danger/10': tone === 'danger',
        'text-success bg-success/10': tone === 'success',
        'text-amber-700 bg-amber-100': tone === 'warning',
        'text-muted bg-border/40': tone === 'muted'
      }
    )
  }

  const getCentroCostoValue = row => row?.centroCosto ?? row?.centroCostos ?? null

  const hasCentroCostoAssignment = centroCosto => {
    if (Array.isArray(centroCosto)) {
      return centroCosto.some(item => {
        if (item == null) return false
        if (typeof item === 'object') return Object.keys(item).length > 0
        return String(item).trim() !== ''
      })
    }

    if (centroCosto && typeof centroCosto === 'object') {
      return Object.keys(centroCosto).length > 0
    }

    if (typeof centroCosto === 'string') {
      const normalized = centroCosto.trim()
      return normalized !== '' && normalized !== '-' && normalized !== '[]'
    }

    return Boolean(centroCosto)
  }

  const rowHasCentroCosto = row => hasCentroCostoAssignment(getCentroCostoValue(row))

  const groupHasCentroCosto = group =>
    Array.isArray(group?.rows) && group.rows.some(row => rowHasCentroCosto(row))

  const centroCostoBadgeClass = hasCentroCosto =>
    clsx(
      'inline-flex items-center justify-center min-w-[3.25rem] px-3 py-1 rounded-full whitespace-nowrap text-[0.55rem] sm:text-[0.6rem] font-semibold tracking-wider leading-tight',
      {
        'text-accent2 bg-accent2/10': hasCentroCosto,
        'text-danger bg-danger/10': !hasCentroCosto
      }
    )

  const renderCentroCostoBadge = hasCentroCosto => (
    <span className={centroCostoBadgeClass(hasCentroCosto)}>
      {hasCentroCosto ? 'ASIGNADO' : 'NO ASIGNADO'}
    </span>
  )

  const renderRowAmount = row => {
    if (row.nombreFolio === 'Boleta') {
      return (
        <>
          <Text className='text-sm font-bold text-right'>
            {formatCurrency(row.montoNetoLiquido)}
          </Text>
          <Text className='text-right text-xs text-accent3'>
            Retención: {formatCurrency(row.montoIvaRetenido)}
          </Text>
          <Text className='text-right text-xs text-gray-500'>
            Total Honorario: {formatCurrency(row.montoTotal)}
          </Text>
        </>
      )
    }
    return (
      <>
        <Text className='text-sm font-bold text-right'>
          {formatCurrency(row.montoTotal)}
        </Text>
        <Text className='text-right text-xs text-accent3'>
          IVA: {formatCurrency(row.montoIvaRetenido)}
        </Text>
        {(row.montoNetoLiquido !== 0 || row.montoExento == null) && (
          <Text className='text-right text-xs text-gray-500'>
            Neto: {formatCurrency(row.montoNetoLiquido)}
          </Text>
        )}
        {row.montoExento != null && row.montoExento !== 0 && (
          <Text className='text-right text-xs text-gray-500'>
            Exento: {formatCurrency(row.montoExento)}
          </Text>
        )}
      </>
    )
  }

  const renderGroupCard = (group, onToggle = handleToggleGroup) => {
    const isExpanded = Boolean(expandedGroups[group.key])
    const hasCentroCosto = groupHasCentroCosto(group)
    const rutLabel =
      group.rut && group.rut !== 'Varios RUT'
        ? formatRut(group.rut)
        : group.rut || 'Varios RUT'
    return (
      <div className='rounded-2xl border border-gray-100 bg-white shadow-sm p-3'>
        <div className='flex items-center justify-between gap-2'>
          <div>
            <Text className='text-xs font-bold text-primary'>
              {group.title}
            </Text>
            <Text className='text-[11px] text-gray-500'>
              {group.label} · {group.count} {group.countLabel}
            </Text>
          </div>
          <button
            type='button'
            className='flex items-center justify-center w-8 h-8 rounded-full bg-gray-100'
            onClick={() => onToggle(group)}
            aria-label={isExpanded ? 'Ocultar detalle' : 'Ver detalle'}
          >
            <KeyboardArrowDownIcon
              className={clsx('transition-transform', { 'rotate-180': isExpanded })}
            />
          </button>
        </div>
        <div className='mt-2 grid grid-cols-2 gap-2 text-xs'>
          <div>
            <Text className='text-[10px] text-gray-400'>Cliente</Text>
            <Text className='text-xs font-semibold'>{group.razonSocial}</Text>
            <Text className='text-[11px] text-gray-500'>{rutLabel}</Text>
          </div>
          <div className='text-right'>
            <Text className='text-[10px] text-gray-400'>Monto total</Text>
            <Text className='text-sm font-bold'>{formatCurrency(group.montoTotal)}</Text>
            <Text className='text-[11px] text-gray-500'>
              IVA: {formatCurrency(group.montoIvaRetenido)}
            </Text>
            {(group.montoNetoLiquido !== 0 || group.montoExento == null) && (
              <Text className='text-[11px] text-gray-500'>
                Neto: {formatCurrency(group.montoNetoLiquido)}
              </Text>
            )}
          </div>
        </div>
        <div className='mt-2 text-xs text-gray-600'>
          <Text className='text-[10px] text-gray-400'>Clasificación</Text>
          <Text className='text-xs font-semibold'>{group.nombreCuenta}</Text>
          {group.codigoCuenta && <Text className='text-[11px] text-gray-500'>{group.codigoCuenta}</Text>}
          <Text className='text-[11px] text-gray-500'>@{group.usuarioClasificador}</Text>
          <button
            type='button'
            className='mt-2 flex items-center justify-center w-8 h-8 rounded-full bg-gray-100 disabled:cursor-not-allowed disabled:opacity-50'
            onClick={() =>
              !group.isEditBlocked &&
              handleClickOpenGroupClassification(group)
            }
            disabled={group.isEditBlocked}
            aria-label='Editar clasificación'
          >
            <EditOutlinedIcon sx={{ color: 'inherit', fontSize: 16 }} />
          </button>
        </div>
        <div className='mt-2 flex items-center justify-between gap-3'>
          <Text className='text-[10px] text-gray-400'>Centro costo</Text>
          {renderCentroCostoBadge(hasCentroCosto)}
        </div>
      </div>
    )
  }

  const renderGroupTableRow = (group, onToggle, keyPrefix = 'group') => {
    const isExpanded = Boolean(expandedGroups[group.key])
    const hasCentroCosto = groupHasCentroCosto(group)
    const rutLabel =
      group.rut && group.rut !== 'Varios RUT'
        ? formatRut(group.rut)
        : group.rut || 'Varios RUT'
    return (
      <tr
        className={clsx(styles.tr, 'bg-white hover:bg-gray-50')}
        key={`${keyPrefix}-${group.key}`}
      >
        <td className={clsx(styles.td, styles.smallCol)}>
          <div className='flex items-center gap-2'>
            <StarIcon style={{ color: '#a1a1aa' }} />
            <div className='relative'>
              <div className={clsx(styles.td, styles.smallCol)}>
                <img src={isologo_SII} className='h-6 w-auto rounded' />
              </div>
            </div>
          </div>
        </td>
        <td className={styles.td}>
          <Text className={styles.boldText}>
            {group.title}
          </Text>
          <Text className={styles.text}>{group.count} {group.countLabel}</Text>
        </td>
        <td className={clsx(styles.td)}>
          <Text className={styles.boldText}>{group.razonSocial}</Text>
          <Text className={styles.text}>{rutLabel}</Text>
        </td>
        <td className={styles.td}>
          <Text className={styles.boldText}>{group.label}</Text>
        </td>
        <td className={styles.td}>
          <div className='flex items-center justify-center gap-2'>
            <div className='min-w-0 flex-1'>
              <Text className={styles.boldText}>{group.nombreCuenta}</Text>
              {group.codigoCuenta && <Text className={styles.text}>{group.codigoCuenta}</Text>}
              <Text className={styles.text}>@{group.usuarioClasificador}</Text>
            </div>
          </div>
        </td>
        <td className={styles.td}>
          <Text className={clsx(styles.boldText, 'text-right')}>{renderCentroCostoBadge(hasCentroCosto)}</Text>
        </td>
        <td className={styles.td}>
          <Text className={clsx(styles.boldText, 'text-xs text-right font-bold')}>
            {formatCurrency(group.montoTotal)}
          </Text>
          <Text className='text-right text-accent3'>
            IVA: {formatCurrency(group.montoIvaRetenido)}
          </Text>
          {(group.montoNetoLiquido !== 0 || group.montoExento == null) && (
            <Text className='text-right text-gray-500'>
              Neto: {formatCurrency(group.montoNetoLiquido)}
            </Text>
          )}
          {group.montoExento != null && group.montoExento !== 0 && (
            <Text className='text-xs text-right text-gray-500'>
              Exento: {formatCurrency(group.montoExento)}
            </Text>
          )}
        </td>
        <td className={styles.td}>
          <span className={statusBadgeClass(group.status)}>
            {normalizeStatus(group.status) || '—'}
          </span>
        </td>
        <td className={styles.td}>
          <div className="flex h-full items-center justify-center space-x-3">
            <div className="flex flex-col text-xs text-gray-500 items-center justify-center">
              <button
                type='button'
                aria-label='Editar'
                disabled={group.isEditBlocked}
                onClick={() => handleClickOpenGroupClassification(group)}
                className='flex text-slate-400 shadow-full-xs rounded-full items-center justify-center w-8 h-8 transition-colors duration-150 bg-white hover:bg-slate-100/50 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-white'
              >
                <EditOutlinedIcon sx={{ color: 'inherit', fontSize: 20 }} />
              </button>
              <Text className="mt-2">Editar</Text>
            </div>
            <div className="flex flex-col text-xs text-gray-500 items-center justify-center">
              <button
                type='button'
                className='flex text-slate-400 shadow-full-xs rounded-full items-center justify-center w-9 h-9 transition-colors duration-150 bg-[#fff] hover:bg-slate-100/50'
                onClick={() => onToggle(group)}
                aria-label={isExpanded ? 'Ocultar detalle' : 'Ver detalle'}
              >
                <KeyboardArrowDownIcon
                  sx={{ fontSize: 24 }}
                  className={clsx('transition-transform', {
                    'rotate-180': isExpanded
                  })}
                />
              </button>
            </div>
          </div>
        </td>
      </tr>
    )
  }

  const renderRowCard = (row, isGroupedDetail, groupKey, isLastGroupedRow) => {
    const cleanStatus = getCleanStatus(row)
    const hasCentroCosto = rowHasCentroCosto(row)
    const isActionBlocked = isStatusActionBlocked(row.status)
    const isEditBlocked = isEditActionBlocked(row.status)
    const isNotaCredito = row.nombreFolio === 'Nota de Crédito Electrónica'
    const canConciliar = !isActionBlocked && !isNotaCredito && row.aprobado !== -5
    const documentCode = getRowDocumentCode(row)
    const canShowBoletaDetail =
      isGroupedDetail &&
      isLastGroupedRow &&
      [39, 41].includes(documentCode) &&
      Boolean(currentBusiness?.rutRepresentante)
    const dayInfo = canShowBoletaDetail ? getBoletaDayInfo(row) : null
    const dayKey =
      dayInfo && groupKey
        ? `${groupKey}-${dayInfo.year}-${dayInfo.month}-${dayInfo.day}`
        : null
    const isBoletaDetailExpanded = Boolean(groupKey && expandedGroups[groupKey])
    const handleToggleBoletaDetail = () =>
      groupKey && handleToggleGroup({ key: groupKey, code: documentCode, rows: [row] })
    return (
      <div
        className={clsx(
          'rounded-2xl border border-gray-100 bg-white shadow-sm p-3',
          isGroupedDetail && 'bg-gray-100'
        )}
      >
        <div className='flex items-start justify-between gap-2'>
          <div className='flex items-start gap-2'>
            {highlightedRows[row.id] ? (
              <StarFullIcon
                style={{ color: '#FFD700', cursor: 'pointer' }}
                onClick={() => toggleHighlight(row.id)}
              />
            ) : (
              <StarIcon
                style={{ color: '#a1a1aa', cursor: 'pointer' }}
                onClick={() => toggleHighlight(row.id)}
              />
            )}
            <div>
              <Text className='text-xs font-bold'>
                {getRowDisplayTitle(row)} · {row.numeroFolio}
              </Text>
              {!row.razonSocial &&
              row.query &&
              row.numeroFolio &&
              pdfAvailabilityByKey[getPdfSummaryKey(row)] ? null : (
                <Text className='text-[11px] text-gray-500'>
                  {(row.rut && formatRut(row.rut)) || 'Varios RUT'}
                </Text>
              )}
            </div>
          </div>
          <span className={statusBadgeClass(cleanStatus)}>
            {normalizeStatus(cleanStatus) || '—'}
          </span>
        </div>

        <div className='mt-2'>
          {!row.razonSocial &&
          row.query &&
          row.numeroFolio &&
          pdfAvailabilityByKey[getPdfSummaryKey(row)] ? (
            <Link
              onClick={() => handleOpenVentaPdf(row)}
              className={styles.pdfLinkCyan}
              style={{
                cursor: pdfLoadingId === row.id ? 'not-allowed' : 'pointer',
                opacity: pdfLoadingId === row.id ? 0.4 : 1
              }}
            >
              {pdfLoadingId === row.id ? <Spinner /> : 'Ver PDF'}
            </Link>
          ) : (
            <Text className='text-xs font-semibold'>
              {row.razonSocial || 'Varios Clientes'}
            </Text>
          )}
        </div>

        <div className='mt-2 grid grid-cols-2 gap-2 text-xs'>
          <div>
            <Text className='text-[10px] text-gray-400'>Fecha</Text>
            <Text className='text-xs font-semibold'>
              {row.fecha && formatDate(row.fecha)}
            </Text>
            <Text className='text-[11px] text-gray-500'>
              {row.fechaVencimiento && formatDate(row.fechaVencimiento)}
            </Text>
            <Text className='text-[11px] text-gray-500'>{row.diasHastaVencimiento}</Text>
          </div>
          <div className='text-right'>{renderRowAmount(row)}</div>
        </div>

        <div className='mt-2'>
          <Text className='text-[10px] text-gray-400'>Clasificación</Text>
          <Text className='text-xs font-semibold'>{row.nombreCuenta}</Text>
          <Text className='text-[11px] text-gray-500'>
            {row.codigoCuenta}{' '}
            <Link
              onClick={() => handleComprobante(row.id, row.nombreFolio, row.folio, 'venta')}
              style={{ cursor: 'pointer' }}
            >
              {row.comprobante || 'ID'}
            </Link>
            {' @' + (row.usuarioClasificador || 'TryLuca')}
          </Text>
        </div>

        <div className='mt-2 flex items-center justify-between gap-3'>
          <Text className='text-[10px] text-gray-400'>Centro costo</Text>
          {renderCentroCostoBadge(hasCentroCosto)}
        </div>

        <div className='mt-3 flex items-center justify-between'>
          <button
            type='button'
            className='flex items-center justify-center w-9 h-9 rounded-full bg-gray-100'
            onClick={() => handleClickOpen(row.id, row.status, 'venta')}
            disabled={isEditBlocked}
            aria-label='Editar movimiento'
          >
            <EditOutlinedIcon sx={{ color: 'inherit', fontSize: 16 }} />
          </button>
          <div className='flex items-center gap-2'>
            <button
              type='button'
              onClick={() => canConciliar && handleClickConciliar(row.id, row.status, row.nombreFolio)}
              className={clsx(
                'flex items-center justify-center w-9 h-9 rounded-full shadow-full-xs',
                {
                  'cursor-not-allowed opacity-50': !canConciliar,
                  'bg-accent2 text-white': row.status === 'COBRADO',
                  'bg-white text-slate-400': row.status !== 'COBRADO'
                }
              )}
            >
              <img
                src={iconoEnlace}
                alt='icono enlace'
                className={clsx('w-5 h-5', { 'brightness-200': row.status === 'COBRADO' })}
              />
            </button>
            <Text className='text-[11px] text-gray-500'>
              {row.status === 'COBRADO' ? 'Conciliado' : 'Conciliar'}
            </Text>
            {dayKey && (
              <div className='flex flex-col items-center'>
                <button
                  type='button'
                  className='flex items-center justify-center w-8 h-8 rounded-full bg-gray-100'
                  onClick={handleToggleBoletaDetail}
                  aria-label={isBoletaDetailExpanded ? 'Ocultar boletas del día' : 'Ver boletas del día'}
                >
                  <KeyboardArrowDownIcon
                    className={clsx('transition-transform', { 'rotate-180': isBoletaDetailExpanded })}
                  />
                </button>
                <Text className='text-[11px] text-gray-500'>
                  {isBoletaDetailExpanded ? 'Ocultar boletas' : 'Ver boletas'}
                </Text>
              </div>
            )}
          </div>
        </div>
        {dayKey && isBoletaDetailExpanded && (
          <div className='mt-3 border-t border-gray-200 pt-2'>
            {renderBoletasList(dayKey, { compact: true, loadingKey: groupKey })}
          </div>
        )}
      </div>
    )
  }

  /*const handleCheckboxClick = (event) => {
    event.stopPropagation()
    event.preventDefault()
    const allApproved = rows.every(item => item.aprobado === 1)
    setPendingApproval(!allApproved)
    setShowPopup(true)
  }*/

  const confirmAction = async () => {
    setShowPopup(false)

    const newData = rows.map(item => ({
        ...item,
        aprobado: pendingApproval ? 1 : 0,
    }))

    setData(newData);
    setPendingApproval(null);

    if (currentBusiness.id) {
        try {
            const ids = rows.map(item => item.id)
            await tablesAPI.patchApproveAll(currentBusiness.id, ids, pendingApproval ? 1 : 0)
        } catch (error) {
            console.error(error)
        }
    }
  }

  useEffect(() => {
      setIsCheckboxChecked(rows.every(item => item.aprobado === 1))
  }, [rows])

   /*const handleNoConsiderarClick = async (row) => {
    try {
      const response = await organizationAPI.getDataLibroContable(
        currentBusiness.id,
        row.id,
        'venta'
      )
      const cuentaData = response.data
      if (!cuentaData) return
      const submitData = {
        idCuenta: cuentaData.idCuenta,
        glosa: cuentaData.glosa,
        fechaVencimiento: cuentaData.fechaVencimiento,
        validation: 0
      }
      await handleSubmit(row.id, submitData)
    } catch (error) {
      console.error('Error al procesar No Considerar:', error)
    }
  }

  const handleSubmit = async (idLibro, data) => {
    try {
      ui.setLoader({ visible: true })
      const updateData = {
        cuentaContableId: data.idCuenta,
        glosa: data.glosa,
        vencimiento: data.fechaVencimiento,
        validation: data.validation
      }
      const response = await organizationAPI.patchDataLibroContable(
        currentBusiness?.id,
        idLibro,
        updateData
      )
      console.info(response)
      setSwitchGetData(true) // Refresca tabla
    } catch (error) {
      console.error(error)
    } finally {
      ui.setLoader({ visible: false })
    }
  }*/

  if (!rows?.[0])
    return (
      <div className="flex flex-col items-center py-12">
        <SearchIcon fontSize="large" className="mb-4 text-gray-400" />
        <Text>{translations.tableAction.noData}</Text>
      </div>
    )
  else if (isMobile)
    return (
      <div className='space-y-3 font-sans'>
        {displayRows.map((item, i) => {
          if (item.type === 'group' || item.type === 'month-group' || item.type === 'week-group') {
            const onToggle = item.type === 'group' ? handleToggleGroup : handleTogglePlainGroup
            return <div key={`${item.type}-${item.group.key}`}>{renderGroupCard(item.group, onToggle)}</div>
          }
          return (
            <div key={item.row?.id ?? `${item.groupKey || 'row'}-${i}`}>
              {renderRowCard(item.row, Boolean(item.isGroupedDetail), item.groupKey, Boolean(item.isLastGroupedRow))}
            </div>
          )
        })}
        {openGroupClassification && (<>
          <ModalGroupClassificationEdit
            open={openGroupClassification}
            setOpen={setOpenGroupClassification}
            idLibro={groupClassificationData.idLibro}
            status={groupClassificationData.status}
            setSwitchGetData={setSwitchGetData}
            groupTitle={groupClassificationData.title}
            groupLabel={groupClassificationData.label}
            centroCostoLibroIds={groupClassificationData.centroCostoLibroIds}
            summary={groupClassificationData.summary}
          /></>)}
        {open && (
          <ModalDialogMotionEditForm
            title='Editar movimiento'
            open={open}
            setOpen={setOpen}
            idLibro={dataModal.idLibro}
            status={dataModal.status}
            type={'venta'}
            nombreFolio={dataModal.nombreFolio}
            setSwitchGetData={setSwitchGetData}
          />
        )}
        {openConciliar && (
          <ModalEditConciliar
            open={openConciliar}
            setOpen={setOpenConciliar}
            idLibro={dataModal.idLibro}
            status={dataModal.status}
            type={'venta'}
            setSwitchGetData={setSwitchGetData}
          />
        )}
        {openComprobante && (
          <ModalViewAdministracion
            openModal={openComprobante}
            setOpenModal={setOpenComprobante}
            comprobanteId={dataComprobante.libroId}
            validation={1}
            folio={dataComprobante.nombreFolio}
            numeroFolio={dataComprobante.folio}
          />
        )}
        {showPopup && (
          <div className='fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50'>
            <div className='relative bg-white px-6 py-5 rounded-xl shadow-2xl w-[320px] text-center'>
              <div className='flex justify-center mb-4'>
                <div className='w-16 h-16 border-2 border-red-500 rounded-full flex items-center justify-center'>
                  <span className='text-red-500 text-4xl'>!</span>
                </div>
              </div>
              <h2 className='font-sans text-base text-gray-800 mt-2'>
                {pendingApproval
                  ? '¿Estás seguro de que deseas aprobar masivamente los movimientos?'
                  : '¿Estás seguro de que deseas desaprobar masivamente los movimientos?'}
              </h2>
              <p className='text-sm text-gray-600 mt-3'>
                Esta acción tiene impacto en el algoritmo de clasificación.
              </p>
              <div className='flex justify-center gap-4 mt-6'>
                <CustomButton title='Cancelar' color='primary' className='rounded-full' onClick={() => setShowPopup(false)} />
                <CustomButton title='Aceptar' color='accent3' className='rounded-full' onClick={confirmAction} />
              </div>
            </div>
          </div>
        )}
      </div>
    )
  else
    return (
      <div className="relative rounded-xl bg-white shadow-sm font-sans">
          <table className={styles.table}>
            <thead className={styles.thead}>
              <tr>
                {orderableCols.map(({ col, field }, i) => (
                  <th key={i} 
                  className={clsx(
                    styles.th,
                    { 'cursor-pointer': field },
                    i === 0 && styles.smallCol
                  )}
                  onClick={() => field && onSort({ col, field })}>
                  {col}
                  {order.col === col && (
                    <KeyboardArrowDownIcon
                      className={clsx('transition-all ml-2 cursor-pointer', {
                        'opacity-40': order.col !== col,
                        'rotate-180': order.direction === 'desc'
                      })}
                    />
                  )}
                </th>
                ))}
              </tr>
            </thead>
            <tbody className={styles.tbody}>
              {displayRows.map((item, i) => {
                if (item.type === 'group' || item.type === 'month-group' || item.type === 'week-group') {
                  const onToggle = item.type === 'group' ? handleToggleGroup : handleTogglePlainGroup
                  return renderGroupTableRow(item.group, onToggle, item.type)
                }
                const row = item.row
                const isGroupedDetail = Boolean(item.isGroupedDetail)
                const rowKey = row?.id ?? `${item.groupKey || 'row'}-${i}`
                const cleanStatus =
                typeof row.status === 'string'
                  ? row.status.replace(/\s*undefined\s*/gi, '').trim()
                  : ''
                const hasCentroCosto = rowHasCentroCosto(row)
                const isActionBlocked = isStatusActionBlocked(row.status)
                const isEditBlocked = isEditActionBlocked(row.status)
                const documentCode = getRowDocumentCode(row)
                const canShowBoletaDetail =
                  isGroupedDetail &&
                  item.isLastGroupedRow &&
                  [39, 41].includes(documentCode) &&
                  Boolean(currentBusiness?.rutRepresentante)
                const dayInfo = canShowBoletaDetail ? getBoletaDayInfo(row) : null
                const dayKey =
                  dayInfo && item.groupKey
                    ? `${item.groupKey}-${dayInfo.year}-${dayInfo.month}-${dayInfo.day}`
                    : null
                const isBoletaDetailExpanded = Boolean(item.groupKey && expandedGroups[item.groupKey])
                return (
                  <Fragment key={rowKey}>
                  <tr
                    className={clsx(
                      styles.tr,
                      isGroupedDetail && 'bg-gray-200 hover:bg-gray-200'
                    )}
                  >
                    {/* Nombre origen */}
                    <td className={clsx(styles.td, styles.smallCol, isGroupedDetail && 'pl-6')}>
                      <div className='flex items-center gap-2'>
                        {highlightedRows[row.id] ? (
                          <StarFullIcon
                            style={{ color: '#FFD700', cursor: 'pointer' }}
                            onClick={() => toggleHighlight(row.id)}
                          />
                        ) : (
                          <StarIcon
                            style={{ color: '#a1a1aa', cursor: 'pointer' }}
                            onClick={() => toggleHighlight(row.id)}
                          />
                        )}
                        <div className='relative'>
                          {currentDate === formatDate(row.fecha) ? (
                            <div className={clsx(styles.td, styles.smallCol)}>
                              <img src={isologo_SII} className='h-5 w-auto rounded mt-2' />
                              <img
                                src={iconNuevo}
                                className='relative z-auto bottom-8 left-5 w-5 h-5 opacity-60'
                              />
                            </div>
                          ) : (
                            <div className={clsx(styles.td, styles.smallCol)}>
                              <img src={isologo_SII} className='h-5 w-auto rounded mt-2' />
                            </div>
                          )}
                        </div>
                      </div>
                    </td>
                    {/* Folio */}
                    <td className={styles.td}>
                      <Text className={styles.boldText}>{getRowDisplayTitle(row)}</Text>
                      {row.query && row.numeroFolio && pdfAvailabilityByKey[getPdfSummaryKey(row)] ? (
                        <Text className={styles.pdfLink}>
                          <Link
                            onClick={() => handleOpenVentaPdf(row)}
                            className={styles.pdfLink}
                            style={{
                              cursor: pdfLoadingId === row.id ? 'not-allowed' : 'pointer',
                              opacity: pdfLoadingId === row.id ? 0.4 : 1
                            }}
                            title='Ver PDF'
                          >
                            {pdfLoadingId === row.id ? <Spinner /> : row.numeroFolio}
                          </Link>
                        </Text>
                      ) : (
                        <Text className={styles.text}>{row.numeroFolio}</Text>
                      )}
                    </td>
                    {/* Cliente */}
                    <td className={clsx(styles.td)}>
                      {!row.razonSocial &&
                      row.query &&
                      row.numeroFolio &&
                      pdfAvailabilityByKey[getPdfSummaryKey(row)] ? (
                        <Link
                          onClick={() => handleOpenVentaPdf(row)}
                          className={styles.pdfLinkCyan}
                          style={{
                            cursor: pdfLoadingId === row.id ? 'not-allowed' : 'pointer',
                            opacity: pdfLoadingId === row.id ? 0.4 : 1
                          }}
                        >
                          {pdfLoadingId === row.id ? <Spinner /> : 'Ver PDF'}
                        </Link>
                      ) : (
                        <>
                          <Text className={styles.boldText}>
                            {row.razonSocial || 'Varios Clientes'}
                          </Text>
                          <Text className={styles.text}>
                            {(row.rut && formatRut(row.rut)) || 'Varios RUT'}
                          </Text>
                        </>
                      )}
                    </td>
                    {/* Fecha */}
                    <td className={styles.td}>
                      <Text className={styles.boldText}>{row.fecha && formatDate(row.fecha)}</Text>
                      <Text className={styles.text}>
                        {row.fechaVencimiento && formatDate(row.fechaVencimiento)}
                      </Text>
                      <Text className={styles.text}>{row.diasHastaVencimiento}</Text>
                    </td>
                    {/* Clasificacion */}
                    <td className={styles.td}>
                      <div className='flex items-center justify-center gap-2'>
                        <div className='min-w-0 flex-1'>
                          <Text className={styles.boldText}>{row.nombreCuenta}</Text>
                          <Text className={styles.text}>{row.codigoCuenta}</Text>
                          <Text className={styles.text}>
                            <Link
                              onClick={() => handleComprobante(row.id, row.nombreFolio, row.folio, 'venta')}
                              className={styles.text}
                              style={{ cursor: 'pointer' }}
                            >
                              {row.comprobante || 'ID'}
                            </Link>
                            {' @' + (row.usuarioClasificador || 'TryLuca')}
                          </Text>
                        </div>
                      </div>
                    </td>
                    <td className={styles.td}>
                        <Text className={clsx(styles.boldText, 'text-right')}>{renderCentroCostoBadge(hasCentroCosto)}</Text>
                      </td>
                    {/* Monto */}
                    <td className={styles.td}>
                      {row.nombreFolio === 'Boleta' ? (
                        <>
                          <Text className={clsx(styles.boldText, 'text-xs text-right font-bold')}>
                            {formatCurrency(row.montoNetoLiquido)}
                          </Text>
                          <Text className='text-right text-accent3'>
                            Retención: {formatCurrency(row.montoIvaRetenido)}
                          </Text>
                          <Text className='text-right text-gray-500'>
                            Total Honorario: {formatCurrency(row.montoTotal)}
                          </Text>
                        </>
                      ) : (
                        <>
                          <Text className={clsx(styles.boldText, 'text-xs  text-right font-bold')}>
                            {formatCurrency(row.montoTotal)}
                          </Text>
                          <Text className='text-right text-accent3'>
                            IVA: {formatCurrency(row.montoIvaRetenido)}
                          </Text>
                          {(row.montoNetoLiquido !== 0 || row.montoExento == null) && (
                            <Text className='text-right text-gray-500'>
                              Neto: {formatCurrency(row.montoNetoLiquido)}
                            </Text>
                          )}
                        </>
                      )}
                      {row.montoExento != null && row.montoExento !== 0 && (
                        <Text className='text-xs text-right text-gray-500'>
                          Exento: {formatCurrency(row.montoExento)}
                        </Text>
                      )}
                    </td>
                    {/* Status */}
                    <td className={styles.td}>
                      <span className={statusBadgeClass(cleanStatus)}>
                        {normalizeStatus(cleanStatus) || '—'}
                      </span>
                    </td>
                    {/* Acciones */}
                    <td className={styles.td}>
                      <div className="flex h-full items-center justify-center space-x-3">
                        <div className="flex flex-col text-xs text-gray-500 items-center justify-center">
                          <div
                            onClick={() => {
                              const isActionBlockedForConciliar = isActionBlocked;
                              const isNotaCredito = row.nombreFolio === 'Nota de Crédito Electrónica';
                              if (!isActionBlockedForConciliar && !isNotaCredito && row.aprobado !== -5) {
                                handleClickConciliar(row.id, row.status, row.nombreFolio);
                              }
                            }}
                            className={clsx('flex text-slate-400 shadow-full-xs rounded-full items-center justify-center w-8 h-8 transition-colors duration-150',
                              {
                                'cursor-not-allowed opacity-50':
                                  isActionBlocked ||
                                  row.nombreFolio === 'Nota de Crédito Electrónica' ||
                                  row.aprobado === -5,
                                'hover:bg-slate-100/50 cursor-pointer':
                                  !(
                                    isActionBlocked ||
                                    row.nombreFolio === 'Nota de Crédito Electrónica' ||
                                    row.aprobado === -5
                                  ),
                                'bg-accent2 text-white': row.status === 'COBRADO',
                                'bg-[#fff]': row.status !== 'COBRADO',
                              }
                            )}
                          >
                            <img src={iconoEnlace} alt="icono enlace" className={clsx('w-5 h-5 transition-all duration-300', {'brightness-200': row.status === 'COBRADO', })} />
                          </div>
                          <Text className="mt-2">{row.status === 'COBRADO' ? 'Conciliado' : 'Conciliar'}</Text>
                        </div>
                        <div className="flex flex-col text-xs text-gray-500 items-center justify-center">
                          <button
                            type='button'
                            aria-label='Editar'
                            disabled={isEditBlocked}
                            onClick={() => handleClickOpen(row.id, row.status, 'venta')}
                            className='flex text-slate-400 shadow-full-xs rounded-full items-center justify-center w-8 h-8 transition-colors duration-150 bg-white hover:bg-slate-100/50 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-white'
                          >
                            <EditOutlinedIcon sx={{ color: 'inherit', fontSize: 20 }} />
                          </button>
                          <Text className="mt-2">Editar</Text>
                        </div>
                        {dayKey && (
                          <div className="flex flex-col text-xs text-gray-500 items-center justify-center">
                            <button
                              type='button'
                              className='flex text-slate-400 shadow-full-xs rounded-full items-center justify-center w-8 h-8 transition-colors duration-150 bg-[#fff] hover:bg-slate-100/50'
                              onClick={() => handleToggleGroup({ key: item.groupKey, code: documentCode, rows: [row] })}
                              aria-label={isBoletaDetailExpanded ? 'Ocultar boletas del día' : 'Ver boletas del día'}
                            >
                              <KeyboardArrowDownIcon
                                className={clsx('transition-transform', { 'rotate-180': isBoletaDetailExpanded })}
                              />
                            </button>
                            <Text className="mt-2">{isBoletaDetailExpanded ? 'Ocultar boletas' : 'Ver boletas'}</Text>
                          </div>
                        )}
                        {/*<div className="flex flex-col text-xs text-gray-500 items-center justify-center">
                          <button
                            onClick={() => {
                              const isAnulado = typeof row.status === 'string' && row.status.includes('ANULADO');
                              if (!isAnulado && row.aprobado === 0) {
                                handleClickApproved(row);
                              }
                            }}
                            className={`${
                              row.aprobado === -5
                                ? 'bg-red-500 hover:bg-red-600 text-white'
                                : row.aprobado !== 0
                                ? 'bg-accent2 text-white hover:bg-white hover:text-slate-400'
                                : 'bg-[#fff] text-slate-400 hover:bg-slate-100/50'
                            } ${
                              (typeof row.status === 'string' && row.status.includes('ANULADO'))
                                ? 'cursor-not-allowed opacity-50'
                                : 'cursor-pointer'
                            } flex shadow-full-xs rounded-full items-center justify-center w-9 h-9 transition-colors duration-150`}
                          >
                            {row.aprobado === -5 ? (
                              <div
                                onClick={() => {
                                  const isAnulado = typeof row.status === 'string' && row.status.includes('ANULADO')
                                  if (!isAnulado) {
                                    handleNoConsiderarClick(row)
                                  }
                                }}
                                className="cursor-pointer"
                              >
                                <BlockIcon />
                              </div>
                            ) : row.aprobado !== 0 ? (
                              <DoneAllIcon />
                            ) : (
                              <CheckOutlinedIcon />
                            )}
                          </button>
                          <Text className="mt-2">
                            {row.aprobado === -5
                              ? translations.tableAction.notConsidered
                              : row.aprobado !== 0
                              ? translations.tableAction.approved
                              : translations.tableAction.approve}
                          </Text>
                        </div>*/}
                      </div>
                    </td>
                  </tr>
                  {dayKey && isBoletaDetailExpanded && renderBoletasList(dayKey, { loadingKey: item.groupKey, dayRow: row, dayHasCentroCosto: hasCentroCosto })}
                  </Fragment>
                )
              })}
              {emptyRows > 0 && (
                <tr className={styles.tr} style={{ height: 89 * emptyRows }}>
                  <td className={styles.td} colSpan={orderableCols.length} aria-hidden />
                </tr>
              )}
            </tbody>
          </table>
        {openGroupClassification && (<>
          <ModalGroupClassificationEdit
            open={openGroupClassification}
            setOpen={setOpenGroupClassification}
            idLibro={groupClassificationData.idLibro}
            status={groupClassificationData.status}
            setSwitchGetData={setSwitchGetData}
            groupTitle={groupClassificationData.title}
            groupLabel={groupClassificationData.label}
            centroCostoLibroIds={groupClassificationData.centroCostoLibroIds}
            summary={groupClassificationData.summary}
          /></>)}
        {open && (
          <ModalDialogMotionEditForm
            title='Editar movimiento'
            open={open}
            setOpen={setOpen}
            idLibro={dataModal.idLibro}
            status={dataModal.status}
            type={'venta'}
            setSwitchGetData={setSwitchGetData}
          />
        )}
        {openConciliar && (
            <ModalEditConciliar
              open={openConciliar}
              setOpen={setOpenConciliar}
              idLibro={dataModal.idLibro}
              status={dataModal.status}
              type={'venta'}
              nombreFolio={dataModal.nombreFolio}
              setSwitchGetData={setSwitchGetData}
            />
        )}
        {openComprobante && (
           <ModalViewAdministracion
           openModal={openComprobante}
           setOpenModal={setOpenComprobante}
           comprobanteId={dataComprobante.libroId}
           validation={1} // O ajusta según lo que necesites
           folio={dataComprobante.nombreFolio}
           numeroFolio={dataComprobante.folio}
         />
        )}
         {showPopup && (
          <div className='fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50'>
            <div className='relative bg-white px-8 py-6 rounded-xl shadow-2xl w-[400px] text-center'>
              <div className='flex justify-center mb-4'>
                <div className='w-16 h-16 border-2 border-red-500 rounded-full flex items-center justify-center'>
                  <span className='text-red-500 text-4xl'>!</span>
                </div>
              </div>
              <h2 className='font-sans text-base text-gray-800 mt-2'>
                {pendingApproval
                  ? '¿Estás seguro de que deseas aprobar masivamente los movimientos?'
                  : '¿Estás seguro de que deseas desaprobar masivamente los movimientos?'}
              </h2>
              <p className='text-sm text-gray-600 mt-3'>
                Esta acción tiene impacto en el algoritmo de clasificación.
              </p>
              <div className='flex justify-center gap-4 mt-6'>
              <CustomButton title='Cancelar' color='primary' className='rounded-full' onClick={() => setShowPopup(false)} />
                <CustomButton title='Aceptar' color='accent3' className='rounded-full' onClick={confirmAction} />
              </div>
            </div>
          </div>
        )}
      </div>
    )
}

export default TableIngresos
